const OFFSET_TOP = 65;
const STICKY_Z_INDEX = '800';
const INDEX_MENU_MODAL = 'index_menu_modal';
const LAYOUT_WRAPPER = '.l-wrapper';

export function initStickyTabs() {
  const stickyElement = document.querySelector<HTMLDivElement>('.ftbl__tabs-menu--dark');
  const elementTop = (stickyElement?.getBoundingClientRect().top || 0) + window.scrollY;
  const outerElement = stickyElement?.closest<HTMLDivElement>('.c-section-divider');

  if (!stickyElement || !outerElement) {
    return;
  }

  if (outerElement && window.innerWidth >= 1024) {
    outerElement.style.height = `${outerElement.getBoundingClientRect().height}px`;
  }

  window.addEventListener('scroll', () => {
    if (window.innerWidth < 1024) {
      return;
    }

    const layoutTop = document.querySelector(LAYOUT_WRAPPER)?.getBoundingClientRect().top || 0;
    const outerRect = outerElement?.getBoundingClientRect();
    const outerLeft = (outerRect?.left || 0) + window.scrollX;
    const outerWidth = outerRect?.width || 1040;

    if (window.scrollY > elementTop - OFFSET_TOP + layoutTop + window.scrollY) {
      stickyElement.style.top = `${OFFSET_TOP}px`;
      stickyElement.style.left = `${outerLeft}px`;
      stickyElement.style.width = `${outerWidth}px`;
      stickyElement.setAttribute('data-sticky', 'true');
    } else {
      stickyElement.style.top = '';
      stickyElement.style.left = '';
      stickyElement.style.width = '';
      stickyElement.removeAttribute('data-sticky');
    }
  });

  window.addEventListener('resize', () => {
    if (window.innerWidth < 1024) {
      stickyElement.style.top = '';
      stickyElement.style.left = '';
      stickyElement.style.width = '';
      stickyElement.removeAttribute('data-sticky');
    } else if (stickyElement.getAttribute('data-sticky') === 'true') {
      const outerRect = outerElement?.getBoundingClientRect();
      const outerLeft = (outerRect?.left || 0) + window.scrollX;
      const outerWidth = outerRect?.width || 1040;
      stickyElement.style.top = `${OFFSET_TOP}px`;
      stickyElement.style.left = `${outerLeft}px`;
      stickyElement.style.width = `${outerWidth}px`;
    }
  });

  window.addEventListener(INDEX_MENU_MODAL, (e) => {
    const isModalOpen = (e as CustomEvent).detail.isModalOpen;
    if (isModalOpen) {
      stickyElement!.style.zIndex = '200';
    } else {
      stickyElement!.style.zIndex = STICKY_Z_INDEX;
    }
  });
}
